import React from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import { useNavigate, useLocation, Link } from 'react-router-dom';

import { useModal } from '../../Modal/ModalContext';
import { useTimeModal } from '../../TimeModal/TimeModalContext';

import { formatDateTime, formatNull } from '../../../Utils/GlobalUtils';

import EditEmailAM from '../../ElementsOfUsersPage/EditEmailAM';
import EditRegion from '../../ElementsOfUsersPage/EditRegion';
import ButtonWithConfirmation from '../../ButtonWithConfirmation';

import LoadingLines from '../../LoadingLines';
import Loading from '../../Loading';
import WarningPanel from '../../WarningPanel';

import IconContainer from '../../../Components/IconContainer';
import { ReactComponent as PlusIcon } from '../../../icons/plus.svg';
import { ReactComponent as PenIcon } from '../../../icons/pen.svg';
import { ReactComponent as CopyIcon } from '../../../icons/copy.svg';

const AMWithRegions = ({ onReloadTable, setOnReloadTable }) => {
    const { openTimeModal } = useTimeModal();

    const [ams, setAms] = React.useState([]);
    const [warning, setWarning] = React.useState('');
    const [loading, setLoading] = React.useState(true);
    const [reload, setReload] = React.useState(true);

    const [currentId, setCurrentId] = React.useState('');
    const [currentRegionId, setCurrentRegionId] = React.useState('');

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        axios.get('/api/get-all-ams', {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(response => {
            if (response.data?.length === 0) {
                setWarning('В системе нет ни одного арбитражного управляющего и региона');
            } else {
                setAms(response.data);
                setWarning('');
            }
        })
        .catch(error => {
            console.error('Ошибка при получении данных:', error);
            setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
        }).finally(() => {
            setLoading(false);
            setReload(false);
            setOnReloadTable(false);
        })
    }, [reload, onReloadTable]);

    const deleteEmailAM = (id) => {
        setLoading(true);
        axios.delete(`/api/delete-email-am?id=${id}`)
        .then(() => {
            openTimeModal(`Email успешно удалён из системы`, 'success');
            setReload(true);
            setOnReloadTable(true);
        })
        .catch((error) => {
            console.error(error);
            openTimeModal(`Не удалось удалить email из таблицы. ${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        })
    };

    const [searchTerm, setSearchTerm] = React.useState('');
    const amRefs = React.useRef({});

    const handleSearchAM = (value) => {
        setSearchTerm(value);

        if (!value.trim()) return;

        const found = ams.find(am => 
            am.am_info?.email?.toLowerCase().includes(value.toLowerCase()) || 
            am.am_info?.lastname?.toLowerCase().includes(value.toLowerCase()) || 
            am.am_info?.firstname?.toLowerCase().includes(value.toLowerCase()) || 
            am.am_info?.surname?.toLowerCase().includes(value.toLowerCase())
        );

        if (found && amRefs.current[found.id]) {
            amRefs.current[found.id].scrollIntoView({
                block: 'center',
            });
        }
    };

    const [currentAction, setCurrentAction] = React.useState('');
    const [isEditRegion, setIsEditRegion] = React.useState(false);
    const [isEditEmailAM, setIsEditEmailAM] = React.useState(false);

    const openSuperModal = (action, subject, id, regionId) => {
        if (subject=='region') setIsEditRegion(true);
        if (subject=='email') setIsEditEmailAM(true);
        setCurrentId(id);
        setCurrentRegionId(regionId);
        setCurrentAction(action);
    }
    const closeSuperModal = () => {
        setIsEditRegion(false);
        setIsEditEmailAM(false);
        setReload(true);
        setLoading(true);
    }

    return (
    <div className='pageWrapper'>
        {isEditEmailAM && <EditEmailAM closeModal={closeSuperModal} id={currentId} regionId={currentRegionId} action={currentAction} onReloadTable={() => {setReload(true); setOnReloadTable(true);}} />}
        {isEditRegion && <EditRegion closeModal={closeSuperModal} id={currentId} regionId={currentRegionId} action={currentAction} onReloadTable={() => {setReload(true); setOnReloadTable(true);}} />}


        <div className='tableContainer'>
            <div className='tableHeaderWrapper'>
                <div className='tableStatus'>
                    <p>Управляющие, прикрепленные к регионам</p>
                    <span
                        className='horizontalContainer'
                    >
                        <input
                            type="text"
                            value={searchTerm}
                            onChange={(e) => handleSearchAM(e.target.value)}
                            placeholder="Поиск управляющего в таблице..."
                            style={{width: '250px'}}
                        />
                        {loading ? 
                        <Loading type='inline' /> 
                        :
                        <IconContainer 
                            Icon={PlusIcon} 
                            label={'Добавить новый регион'}
                            onClick={() => openSuperModal('add', 'region')}
                            size = '17' 
                            color = 'blue' 
                            className = '' 
                        />}
                    </span>
                </div>
                <div className='tableHeader' style={{ gridTemplateColumns: '20fr 25fr 25fr 20fr 15fr' }}>
                    <div>Субъект</div>
                    <div>Email</div>
                    <div>Арбитражный управляющий</div>
                    <div>Статус</div>
                    <div>
                        <span style={{width: '100%', display: 'flex', justifyContent: 'end'}}>
                            Действия
                        </span>
                    </div>
                </div>
            </div>
            {(ams.length===0 && loading) ? <LoadingLines count='5' heightLine='72' />
            : warning ? <WarningPanel text={warning} inTable={true} buttonText='Обновить' buttonAction={() => setReload(true)} />
            : ams.map((am, i) => (
                <React.Fragment key={am.id}>
                    <div 
                        className='tableRow nonActive' 
                        style={{ gridTemplateColumns: '20fr 25fr 25fr 20fr 15fr', backgroundColor: am.am_info ? 'inherit' : '#f9f9f9' }}
                    >
                        <div>
                            {am.region_name}
                        </div>
                        {am.am_info ?
                        <>
                        <div>
                            <span style={{display: 'flex', gap: '4px', alignItems: 'center'}}>
                                <p
                                    ref={el => (amRefs.current[am.id] = el)}
                                    className={(searchTerm.trim() && am.am_info?.email.toLowerCase().includes(searchTerm.toLowerCase())) ? 'highlightedText' : ''}
                                >
                                    {am.am_info?.email}
                                </p>
                                <IconContainer 
                                    Icon={CopyIcon} 
                                    label={'Скопировать'} 
                                    onClick={() => {
                                        navigator.clipboard.writeText(am.am_info?.email);
                                        openTimeModal('Email скопирован', 'success');
                                    }} 
                                    size = '15' 
                                    color = 'black' 
                                    className = '' 
                                />
                            </span>
                            {am.am_info?.note && <p className='description'>({am.am_info.note})</p>}
                        </div>
                        {am.am_info?.user_id ?
                        <Link
                            to={`/account/${am.am_info.user_id}`}
                            ref={el => (amRefs.current[am.id] = el)}
                            className={(searchTerm.trim() && (am.am_info?.lastname.toLowerCase().includes(searchTerm.toLowerCase()) || am.am_info?.firstname.toLowerCase().includes(searchTerm.toLowerCase()) || am.am_info?.surname.toLowerCase().includes(searchTerm.toLowerCase()))) ? 'aWithLink highlightedText' : 'aWithLink'}
                        >
                            {am.am_info.lastname ? `${am.am_info.lastname} ${am.am_info.firstname} ${am.am_info.surname}` : '—'}
                        </Link>
                        :
                        formatNull('')
                        }
                        <div>
                            {am.am_info.approval === 'Активен' && <p className='textPill green'>Зарегистрирован</p>} 
                            {am.am_info.approval === 'На рассмотрении' && <p className='textPill blue'>На рассмотрении</p>} 
                            {am.am_info.approval === 'Отключен' && <p className='textPill orange'>Отключен</p>} 
                            {!am.am_info.approval && <p className='textPill red'>Не зарегистрирован</p>} 
                            {am.am_info.created_at && <span className='description'>{formatDateTime(am.am_info.created_at)}</span>}
                        </div>
                        <div>
                            <span style={{width: '100%', display: 'flex', justifyContent: 'end'}}>
                                <IconContainer Icon={PenIcon} onClick={() => {openSuperModal('change', 'email', am.id, '')}} size = '16' color = 'blue' className = '' />
                                <ButtonWithConfirmation id={am.id} entryFunc={() => deleteEmailAM(am.id)} />
                            </span>
                        </div>
                        </>
                        :
                        <>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div>
                                <button className='tableButton' onClick={() => openSuperModal('add', 'email', '', am.region_id)}>
                                    <svg viewBox="0 0 24 24" id="plus"><path d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z"></path></svg>
                                    Добавить email
                                </button>
                            </div>
                        </>}
                    </div>
                </React.Fragment>
            ))}
        </div>
    </div>
    )
}

export default AMWithRegions;